module.exports = __webpack_public_path__ + "img/plan-3-BG.17d840a3.png";